import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup,} from "@angular/forms";
import { CommunicationMessageTypes } from "../../../../../shared/enum-files/general-enums";
import { ShareConfigService } from "../../../../../shared/services/shareConfig.service";
import { FroalaEditorOptions } from "../../../../../shared/services/template-froala-options";
import { VariablePopupService } from "../../../../../shared/services/variable-popup.service";

@Component({
  selector: 'app-sms-template',
  templateUrl: './sms-template.component.html',
  styleUrls: ['./sms-template.component.scss']
})

export class SmsTemplateComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() notificationType:any;
  @Output() changeSMS = new EventEmitter();

  // Template Editor Froala
  public froalaEditorOptions = new FroalaEditorOptions();
  public setEditorOptions: object;
  public allowedVariblesFor: string = 'appointment';

  public isSMSVariablesPopupEnabled: boolean = false;


  constructor(private variablePopupService: VariablePopupService,private shareConfigService: ShareConfigService) { }


  ngOnInit() {
    this.setEditorOptions = this.froalaEditorOptions.setEditorOptions(2000);
    this.setEditorOptions['toolbarButtons'] = ['my_dropdown'];
    this.froalaEditorOptions.customPopupBtn();
  }

  openVariablePopupSms() {
    this.isSMSVariablesPopupEnabled = true;
    let variablePopupPayload: any = {};
    let msg = this.froalaEditorOptions.editorRefernce.html.get();
    // variablePopupPayload.listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObj(msg);
    variablePopupPayload.listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObjV3(msg);
    variablePopupPayload.allowedVariblesFor = this.allowedVariblesFor;
    variablePopupPayload.isOpenPopup = true;
    variablePopupPayload.communicationType = "smsMsg";
    this.variablePopupService.variablePopupOpened = 'sms';
    this.variablePopupService.variablePopupPayload = variablePopupPayload;
    this.variablePopupService.changeInVariablePopupPayload();
  }

  smsChange(data) {
    if(!this.shareConfigService.listOfUsedVariableObj[this.notificationType]){
      this.shareConfigService.listOfUsedVariableObj[this.notificationType] = {};
    }
    this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.SmsTemplateMsg] = this.variablePopupService.getListOfUsedVariableFormulasInMsg(data);
    this.changeSMS.emit(data);
    this.isSMSVariablesPopupEnabled = false;
  }

  UpdatePopUpStatus(e) {
    // let smsText = this.variablePopupService.insertFormulaIntoEditor(this.variablePopupService.listOfUsedVariableObj, this.froalaEditorOptions);
    let smsText = this.variablePopupService.insertFormulaIntoEditorV3(this.variablePopupService.listOfUsedVariableObj, this.froalaEditorOptions);
    this.form.patchValue({ SMSText: smsText });
    this.changeSMS.emit(smsText);
    this.isSMSVariablesPopupEnabled = false;
    if(!this.shareConfigService.listOfUsedVariableObj[this.notificationType]){
      this.shareConfigService.listOfUsedVariableObj[this.notificationType] = {};
    }
   
    this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.SmsTemplateMsg] = [];
    if(this.variablePopupService.listOfUsedVariableObj && this.variablePopupService.listOfUsedVariableObj.length > 0){
      this.variablePopupService.listOfUsedVariableObj.map((item:any) => {
        this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.SmsTemplateMsg].push(item.formula);
      })
    }
  }

  CancelPopUpStatus(e){
    this.isSMSVariablesPopupEnabled = false;
  }

}


// WEBPACK FOOTER //
// ./src/app/appointments/appointment-types/add-appointment-type/messages/sms-template/sms-template.component.ts